import Toggle from "PFComponents/toggle/toggle";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { WorkforceCalendarData } from "../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";

const HeatMapToggle = () => {
  const {
    splitMode,
    calendarData: { heatMapEnabled, setHeatMapEnabled }
  } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { t } = useTranslation("bookingModule");

  const handleChange = useCallback((enabled: boolean) => {
    setHeatMapEnabled(enabled);
  }, []);

  return (
    <div>
      <Toggle
        label={t("workforce.heatMap")}
        checked={heatMapEnabled}
        onChange={handleChange}
        inline
        disabled={splitMode}
      />
    </div>
  );
};

export default HeatMapToggle;
